import axios from 'axios';
const API_PREFIX = process.env.REACT_APP_API_PREFIX;

export const getReportData = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/ministry-reports${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getStageIncidents = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(`${API_PREFIX}/ministry-reports/stage${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getReasonCategoryIncidents = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(`${API_PREFIX}/ministry-reports/getReasonCategoryIncidents${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getMajorMinorIncidents = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(
      `${API_PREFIX}/ministry-reports/getMajorMinorIncidents
${filter}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getDateAndCategoryWiseIncidents = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(
      `${API_PREFIX}/ministry-reports/getDateAndCategoryWiseIncidents
${filter}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getIncidentById = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(
      `${API_PREFIX}/ministry-reports/getIncidentById
${filter}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getIncidentsByCategoryAndDate = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(
      `${API_PREFIX}/ministry-reports/getIncidentsByCategoryAndDate
${filter}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getTimeTrackerData = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(
      `${API_PREFIX}/ministry-reports/getProdTimeTracker
${filter}`
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getAllIncidents = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  // Avoid trailing ? or ?
  if (filter === '?') filter = '';

  return await axios
    .get(`${API_PREFIX}/ministry-reports/get-all-incidents${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const uploadIncidents = async (formData) => {
  return await axios
    .post(`${API_PREFIX}/datauploads/uploadMonitoringData`, formData)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const updateRemarks = async (formData) => {
  return await axios
    .put(`${API_PREFIX}/ministry-reports/updateRemarks`, formData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const getUploadedStatus = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');

  return await axios
    .get(`${API_PREFIX}/ministry-reports/getUploadedStatus${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error);
      return error?.response?.data;
    });
};

export const deleteIncident = async (id) => {
  return await axios
    .delete(`${API_PREFIX}/ministry-reports/delete-incident/${id}`)
    .then((res) => {
      return res.data;
    });
};
